import {
  isEmpty,
  isArray,
} from 'src/helpers/check';
import { PERMISSIONS } from 'src/constants';

export const doesUserHavePermission = (permissionToCheck, userPermissionList) => {
  if (isEmpty(permissionToCheck) || !isArray(userPermissionList)) {
    return false;
  }

  return !!userPermissionList.includes(permissionToCheck);
};

export const doesUserHaveOneOfPermissions = (permissionToCheckList, userPermissionList) => {
  if (!isArray(permissionToCheckList) || !isArray(userPermissionList)) {
    return false;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const permission of permissionToCheckList) {
    if (doesUserHavePermission(permission, userPermissionList)) {
      return true;
    }
  }

  return false;
};

export const canDisplayAddToGroupField = (user) => {
  const {
    textingProvider,
    userRole,
  } = user || {};
  const {
    permissions,
  } = userRole || {};

  return textingProvider === 'CP' && doesUserHavePermission(PERMISSIONS.PERMISSIONS_SYSTEM_CODE.GROUP_VIEW, permissions);
};

/* ***************************************************************************
 * canSendMultipleAttachments — CON-1925
 * The multi-attachment MMS beta: CP texting AND the MULTI_ATTACHMENT_MMS
 * permission, both. The number of attachments allowed comes from
 * state.account.mmsAttachmentPolicy.maxAttachments; this only says whether
 * the user is in the beta at all. Same shape as canDisplayAddToGroupField.
 *************************************************************************** */
export const canSendMultipleAttachments = (user) => {
  const {
    textingProvider,
    userRole,
  } = user || {};
  const {
    permissions,
  } = userRole || {};

  return textingProvider === 'CP'
    && doesUserHavePermission(PERMISSIONS.PERMISSIONS_SYSTEM_CODE.MULTI_ATTACHMENT_MMS, permissions);
};
